<template>
  <span>{{ getTranslatedText('Balance') }}: {{ formattedBalance }}</span>
</template>

<script>
import languageMixins from '@/mixins/language-mixins';
import { mapGetters } from 'vuex';

export default {
  mixins: [languageMixins],
  computed: {
    ...mapGetters('stateBalance', {
      balance: 'balance',
    }),
    currencySymbol() {
      return this.$store.state.accountSetting.currency_symbol;
    },
    formattedBalance() {
      return `${this.currencySymbol} ${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.balance)}`;
    },
  },
  created() {
    this.checkForPageRefresh();
  },
  methods: {
    checkForPageRefresh() {
      const refreshed = sessionStorage.getItem('page_refreshed');
      if (!refreshed) {
        this.fetchBalance();
        sessionStorage.setItem('page_refreshed', 'true');
      }
    },
    async fetchBalance() {
      await this.$store.dispatch('stateBalance/fetchBalance');
      sessionStorage.removeItem('page_refreshed');
    }
  }
};
</script>